import cx from 'classnames'
import RAvatar from 'react-avatar'
import styles from './avatar.module.scss'

interface IAvatarProps {
  name: string
  src?: string
  className?: string
  isLarge?: boolean
  size?: number
}

const Avatar = (props: IAvatarProps) => {
  const { src, name, className, isLarge, size } = props
  const sizeStyle = size ? { width: size, height: size } : undefined

  return src ? (
    <img src={src} className={cx(styles.avatar, className, { [styles.large]: isLarge })} style={sizeStyle} alt="avatar" />
  ) : (
    <RAvatar name={name} className={cx(styles.avatar, className, { [styles.large]: isLarge })} style={sizeStyle} maxInitials={2} />
  )
}

export default Avatar
